import { useState } from 'react'
import IconsTextNavigation from 'components/global/IconsTextNavigation'
import RequestMentorModal from 'pages/Events/Views/Common/Modals/RequestMentorModal'
import { creationEventStore } from 'state/event/eventCreationStore'
import { EventResp } from 'types/event/events'

const MentorRequest = () => {
  const { eventData }: { eventData: EventResp } = creationEventStore(store => ({
    eventData: store.eventData,
  }))
  const [mentorRequestModal, setMentorRequestModal] = useState<boolean>(false)

  return (
    <>
      <div onClick={() => setMentorRequestModal(true)}>
        <IconsTextNavigation
          iconName="MagnifyingGlass"
          heading="Mentor Request"
          isCompleted={eventData?.mentorRequestIds?.length ? true : false}
        />
      </div>
      {mentorRequestModal && (
        <RequestMentorModal
          openModal={mentorRequestModal}
          setOpenModal={setMentorRequestModal}
          reference="event"
          referenceId={eventData._id}
        />
      )}
    </>
  )
}

export default MentorRequest
